export default "__VITE_ASSET__BtXqNiyz__"